"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderRight = exports.HeaderCenter = exports.HeaderLeft = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _container = _interopRequireDefault(require("../container"));

var _index = _interopRequireDefault(require("./index.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Main header
// ===========
var MainHeader = function MainHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      type = _ref.type;
  return _react["default"].createElement("header", {
    className: (0, _classnames["default"])(_index["default"].MainHeader, className)
  }, _react["default"].createElement(_container["default"], {
    type: type,
    className: _index["default"].Container
  }, children));
};

MainHeader.propTypes = {
  className: _propTypes["default"].string,
  type: _propTypes["default"].string,
  children: _propTypes["default"].node
};
MainHeader.defaultProps = {
  type: 'full'
};
var _default = MainHeader;
exports["default"] = _default;

var HeaderLeft = function HeaderLeft(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].HeaderLeft, className)
  }, children);
};

exports.HeaderLeft = HeaderLeft;
HeaderLeft.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};

var HeaderCenter = function HeaderCenter(_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].HeaderCenter, className)
  }, children);
};

exports.HeaderCenter = HeaderCenter;
HeaderCenter.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};

var HeaderRight = function HeaderRight(_ref4) {
  var children = _ref4.children,
      className = _ref4.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].HeaderRight, className)
  }, children);
};

exports.HeaderRight = HeaderRight;
HeaderRight.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};